import { Injectable } from '@angular/core';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentUploadService {

  constructor(private dataProvider: DataService) {
  }

  GetDemandWiseDocuments(apiUrl: string, demandId: number): Promise<any> {
    return this.dataProvider.Get<any>(apiUrl, demandId).toPromise();
  }
  GetDemandViewFile(apiUrl: string, url: string): Promise<any> {
    return this.dataProvider.Get<any>(apiUrl, url).toPromise();
  }
  GetDemandDownloadFile(apiUrl: string, model: any): Promise<any> {
    return this.dataProvider.GetAllwithHeaders<any>(apiUrl, model).toPromise();
  }
  DeleteDocument(apiUrl: string, model:any): Promise<any>{
    return this.dataProvider.Post<any>(apiUrl, model).toPromise();
  }
}